
export function reportUrl({ statUrl, action, subkey }) {
    const url = `${statUrl}&action=${action}&subkey=${subkey}&r=${Date.now()}`;
    new Image().src = url;
}
